import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { formatDateTime, formatDateTimezon } from "../../common-data/Converts";
import FreshLeadListingsMobile from "./FreshLeadListingsMobile";
import { CallIcon } from "../../../images/icons/icons";

const FreshLeadListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const { freshLeads, freshLeadsLoading, freshLeadsError } = useSelector(
    (state) => state.prospects
  );

  const iniLeadsDatas = {
    data: [],
    pagination: [],
  };
  const [leadsDatas, setLeadsDatas] = useState(iniLeadsDatas);

  useEffect(() => {
    if (
      !freshLeadsLoading &&
      !freshLeadsError &&
      freshLeads?.status &&
      freshLeads?.data
    ) {
      setLeadsDatas((prev) => ({
        ...prev,
        data: freshLeads.data,
        pagination: freshLeads?.pagination,
      }));
    } else {
      setLeadsDatas(iniLeadsDatas);
    }
  }, [freshLeadsLoading, freshLeadsError, freshLeads]);

  const tbColumns = [
    {
      dataField: "added_to_lead",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          {row?.added_to_lead ? (
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#000",
                color: "#fff",
                borderRadius: "8px",
                cursor: row?.added_to_lead ? "pointer" : "not-allowed",
                fontSize: "15px",
                padding: "10px",
              }}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  // modName: "follow-up",
                  modName: "view-lead-journey",
                  from: "fresh-lead",
                }))
              }
            >
              View Lead
            </button>
          ) : (
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#C90808",
                color: "#fff",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "15px",
                padding: "10px",
              }}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "add-to-lead",
                  from: "fresh-lead",
                }))
              }
            >
              Add To LMS
            </button>
          )}
        </div>
      ),
    },
    {
      dataField: "uid",
      text: "member info",
      formatter: (_, row) => {
        return (
          <span className="tb-data underline">
            {row?.name || "NA"}
            <br />
            <small className="lowercase">
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym",
      formatter: (_, row) => {
        return (
          <span className={`tb-data minWidth150`}>{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "lead_status",
      text: "Lead Status",
      formatter: (_, row) => {
        const isNotLeadStatus = !row?.lead_status;

        return (
          <span
            className={`tb-data ${
              isNotLeadStatus ? "" : "minWidth100 withPadding borderRdius27"
            }`}
            style={{
              background: isNotLeadStatus
                ? ""
                : row?.lead_status === "converted"
                ? "#379C00"
                : row?.lead_status === "pending"
                ? "#EB8317"
                : !row?.lead_status
                ? "gray"
                : "#D90000",
              color: isNotLeadStatus ? "" : "#fff",
            }}
          >
            {row?.lead_status || "NA"}
          </span>
        );
      },
    },
    // {
    //   dataField: "source_name",
    //   text: "Lead Source",
    //   formatter: (_, row) => {
    //     return (
    //       <span className={`tb-data`}>
    //         {row?.source_name?.replace(/_/g, " ") || "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "added_on_lead",
      text: "Added to LMS",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.added_on_lead ? formatDateTimezon(row.added_on_lead) : "-"}
            <br />
            <small className="gray underline">
              {row?.add_to_lms_time_dif || "-"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "assigned_to",
      text: "Assigned to",
      formatter: (_, row) => {
        return (
          <span className="tb-data underline">
            {row?.assigned_to_name || "NA"}
            <br />
            <small className="lowercase">
              {row?.assigned_to_mobile || ""}
              <br />
              {row?.assigned_to_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "click_to_call",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "click-to-call",
                  rowData: row,
                }))
              }
            >
              <CallIcon color="#000" />
            </button>
          </div>
        );
      },
    },
  ];
  
  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile">
        {freshLeadsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={leadsDatas.data}
            tableColumns={tbColumns}
            tablePagination={leadsDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {freshLeadsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <FreshLeadListingsMobile
            tableData={leadsDatas.data}
            tablePagination={leadsDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            isUntrackedWatiLead={true}
          />
        )}
      </div>
    </>
  );
};

export default FreshLeadListings;
